(function() {

  'use strict';

  eclipseApp.controller('registrationCompleteCtrl', ['$scope', '$location', '$modalInstance', '$translate',
    'uteEndpoint', '$http', '$timeout', '$window', 'janrainService', 'util', 'env', 'uteLocale', 'ute.datalayer.common.service', '$state',
    function($scope, $location, $modalInstance, $translate, uteEndpoint, $http, $timeout, $window, janrainService,
      util, env, uteLocale, dataLayerService, $state) {

      $scope.autoReg = {};
      $scope.selectedscreen = ''; /* what screen to choose from keeps controller same*/
      $scope.loading = true; /* when to show loading icon specially when doing http */
      $scope.autoRegComplete = false;
      $scope.securityQuestionCount = 20; /* we dont have count because of JSON is flattened while translation  */
      $scope.lang = uteLocale.language;
      $scope.emailRegLinkSend = {
        message: {}
      };
      $scope.manualRegisrationComplete = false;

      $scope.validationUrl = util.getParameterByName('verification_code');
      $scope.autoReg.secretQuestion = 0;


      /* rule for email registration send link form */
      $scope.emailRegLinkSendRule = {
        username: {
          required: 'true'
        },
      };

      $scope.blurPassword = function(autoRegCompleteForm) {
          console.info('blur happened');
          if (autoRegCompleteForm.confirmPassword.$touched == true) {
            autoRegCompleteForm.confirmPassword.$setValidity('passwordMismatch', ($scope.autoReg.password === $scope.autoReg.confirmPassword));
          }

          console.info(angular.copy($scope.autoReg), 'pwReset');
          console.info(angular.copy(autoRegCompleteForm), 'passwordResetForm');
          console.warn(autoRegCompleteForm.confirmPassword.$touched);


        }
        //FUSS-2242 : Show password functionality - start
      $scope.showPass = function() {
        $timeout(function() {
          //Show New password:
          $(".showPasswordButton").hide();
          $(".hidePasswordButton").hide();
          $(".showConfirmPasswordButton").hide();
          $(".hideConfirmPasswordButton").hide();
          $("#password").on("keyup", function() {
            if ($(this).val().length > 0) {
              $(".showPasswordButton").show();
              $(".hidePasswordButton").hide();
            } else {
              $(".hidePasswordButton").hide();
              $(".showPasswordButton").hide();
            }
          });
          $(function() {
            $("#password").each(function(index, input) {
              var $input = $(input);
              $translate('global.cta.show').then(function(trans) {
                  $(".showMyPasswordReg").html(trans);
              })
              $(".showMyPasswordReg").click(function() {
                var change = "";
                if ($(".showMyPasswordReg").html() === 'SHOW' || $(".showMyPasswordReg").html() === 'VOIR') {
                  $translate('global.cta.hide').then(function(trans) {
                      $(".showMyPasswordReg").html(trans);
                      $(".hidePasswordButton").show();
                      $(".showPasswordButton").hide();
                   })
                  change = "text";
                } else {
                  $translate('global.cta.show').then(function(trans) {
                      $(".showMyPasswordReg").html(trans);
                      $(".hidePasswordButton").hide();
                      $(".showPasswordButton").show();
                  });
                  change = "password";
                }
                  $input.attr('type', change);
              });
                $input.focus(function() {
                  $translate('global.cta.show').then(function(trans) {
                      $(".showMyPasswordReg").html(trans);
                  });
              });
            });
          });

          //Show Confirm password:
          $("#confirmPassword").on("keyup", function() {
            if ($(this).val().length > 0) {
              $(".showConfirmPasswordButton").show();
              $(".hideConfirmPasswordButton").hide();
            } else {
              $(".hideConfirmPasswordButton").hide();
              $(".showConfirmPasswordButton").hide();
            }
          });
           $(function() {
              $("#confirmPassword").each(function(index, input) {
                var $input = $(input);
                $translate('global.cta.show').then(function(trans) {
                    $(".showConfirmMyPasswordReg").html(trans);
                })
                $(".showConfirmMyPasswordReg").click(function() {
                  var change = "";
                  if ($(".showConfirmMyPasswordReg").html() === 'SHOW' || $(".showConfirmMyPasswordReg").html() === 'VOIR') {
                    $translate('global.cta.hide').then(function(trans) {
                        $(".showConfirmMyPasswordReg").html(trans);
                        $(".hideConfirmPasswordButton").show();
                        $(".showConfirmPasswordButton").hide();
                     })
                    change = "text";
                  } else {
                    $translate('global.cta.show').then(function(trans) {
                        $(".showConfirmMyPasswordReg").html(trans);
                        $(".hideConfirmPasswordButton").hide();
                        $(".showConfirmPasswordButton").show();
                    });
                    change = "password";
                  }
                    $input.attr('type', change);
                });
                  $input.focus(function() {
                    $translate('global.cta.show').then(function(trans) {
                        $(".showConfirmMyPasswordReg").html(trans);
                    });
                });
              });
            });
          }, 10);
        }
        //FUSS-2242 : Show password functionality - end


      /* rule for registration complete form  */
      $scope.autoRegCompleteRule = {
        password: {
          type: 'text',
          minlength: 7,
          maxlength: 16,
          'pattern': '^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9!@#$%^&*.:;\'"<>{}\\[\\]]+)$'
        },
        confirmPassword: {
          type: 'text',
          minlength: 2,
          maxlength: 16,
          'pattern': '^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9!@#$%^&*.:;\'"<>{}\\[\\]]+)$'

        },
        secretQuestionAns: {
          type: 'text',
          minlength: 2,
          maxlength: 50
        },
        secretQuestion: {
          type: 'text',
          minlength: 2,
          maxlength: 16
        }

      };


      $scope.popupClosewithMessage = function(message) {
        $scope.autoRegComplete = true;
        $modalInstance.close($scope);
      };

      $scope.closeExistingModal = function() {
        $modalInstance.close();
      };

      $scope.redirectToLogin = function (  ) {
        $modalInstance.close();
        $state.go('signin');
      };

      /* close icon on top of the pop up */
      $scope.cancel = function(triggerClose) {
        $modalInstance.close($scope.popupLogin);
        $scope.triggerClose = triggerClose;
        window.location.href = env.fidoHomePageUrl;
      };

      /* clean up has happend do some stuff here
        pop other window */
      $modalInstance.result.finally(function() {
        var timeout = 0;
        if ($scope.manualRegisrationComplete == true) {
          timeout = 500;
        }
        $timeout(
          function() {

            /* enable this section to sanitize URL
            console.info('in timeout');

            var myNewUrl='/'
            $location.url(myNewUrl);
            $location.replace();
            $window.history.pushState(null, 'any', $location.absUrl());
            */

            if ($scope.autoRegComplete == true || $scope.triggerClose == 'noErrorSuccessLogin') {
              $state.go('signin');
              // if ($scope.triggerClose == 'noErrorSuccessLogin') {
              //   $state.go('signin');
              // } else {
              //   janrainService.setSuccessErrorMessage(true);
              //   $translate('global.message.registrationCompletionConfirmation')
              //     .then(function(translatedValue) {
              //       janrainService.setJanrainMessage(translatedValue);
              //       $state.go('signin');
              //     });
              // }
            }
          }, timeout);
      });

      /* validate URL starts here */
      $scope.autoReg.uuid = '';
      $http({
        method: 'POST',
        url: uteEndpoint('v1/validateURL'),
        data: $.param({
          code: $scope.validationUrl,
          screenToRender: 'registration'
        }),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }

      }).success(function(data, status, headers, config) {
        if (data.error) {
          $scope.loading = false;
          $scope.selectedscreen = 'setError';
        } else if (data.error == false && data.isExpired == true) {
          /* link is expired show form to enter email */
          $scope.loading = false;
          $scope.selectedscreen = 'linkExpired';
          $scope.autoReg.email = 'linkExpired';
          dataLayerService.track({}, false, [0, 1, 4], {mappingKey: 'autoReg.resendLinkModal'}); // Tracking link expired modal on load
        } else if (!data.error && data.isQASet == true) {
          $scope.manualRegisrationComplete = true;
          $scope.loading = false;
          $scope.autoReg.uuid = data.uuid;
          $translate('global.message.registrationCompletionConfirmation')
            .then(function(translatedValue) {
              $scope.popupClosewithMessage(translatedValue);
            });
          $scope.showPass();

        } else if (data && data.error == false && data.isProfileTypeSet === true) {
          $scope.loading = false;
          $scope.selectedscreen = 'askAnswer';
          dataLayerService.track({}, false, [0, 1, 4], {mappingKey: 'autoReg.setPasswordModal'}); // Tracking set password modal on load
          $scope.showPass();
          $scope.autoReg.uuid = data.uuid;
        } else if (data && data.error == false && data.isProfileTypeSet === false) {
          $scope.loading = false;
          $scope.autoReg.uuid = data.uuid;
          $translate('global.message.registrationCompletionConfirmation')
          .then(function(translatedValue) {
            $scope.popupClosewithMessage(translatedValue);
          });
        }
      }).error(function(data, status, headers, config) {
        $scope.loading = false;
        $scope.selectedscreen = 'errorServerSideValidation';
      });
      /* validate URL ends here */



      /** link expired form starts here */
      $scope.autoReg.errorLinkForm = false;
      $scope.completedLinkexpiredForm = function(formName) {

        if (!util.validateFormOnSubmit(formName)) {
          return false;
        }

        dataLayerService.track({}, false, [0, 1, 4], {mappingKey: 'autoReg.resendLinkButton'});

        $http({
          method: 'POST',
          url: uteEndpoint('v1/expiredLink'),
          data: $.param({
            emailAddress: formName.username.$modelValue,
            screenToRender: 'registration',
            language: $scope.lang
          }),
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }

        }).success(function(data, status, headers, config) {

          if (!(data.error || data.status == 'Failure')) {
            $scope.autoReg.linkExpiredEmail = formName.username.$modelValue;
            $scope.selectedscreen = 'setLinkExpiredSubmitSuccess';
          } else {
            $scope.emailRegLinkSend.error = 'success-linkexpired-alreadysent';
          }
        }).error(function(data, status, headers, config) {
          $scope.emailRegLinkSend.error = 'success-linkexpired-alreadysent';
          $scope.emailRegLinkSend.errorCode = _.get(data, 'errorCode');
        });

      };
      /** link expired form ends  here */

      /* registration QA/pass form has been submitted */
      $scope.completedForm = function(formName) {

        /*if ($scope.autoReg.secretQuestion == 0) {
            formName.secretQuestion.$setValidity('required', false);
        }*/

        if (!util.validateFormOnSubmit(formName)) {
          return false;
        }

        $http({
          method: 'POST',
          url: uteEndpoint('loginCompleteRegistration'),
          data: $.param({
            password: formName.password.$modelValue,
            //securityQuestion: $scope.autoReg.secretQuestion,
            //securityAnswer: formName.secretQuestionAns.$modelValue,
            uuid: $scope.autoReg.uuid,
            code: $scope.validationUrl
          }),
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).success(function(data, status, headers, config) {
          if (!(data.error || data.status == 'Failure')) {
            dataLayerService.track({}, false, [0, 1, 4], {mappingKey: 'autoReg.setPasswordButtonFinish'});
            /* security QA set, pop up login with success */
            $translate('global.message.registrationCompletionConfirmation')
              .then(function(translatedValue) {
                $scope.popupClosewithMessage(translatedValue);
              });

          } else {
            $scope.selectedscreen = 'setAutoRegSubmitFailure';
            $scope.showPass();
          }
        }).error(function(data, status, headers, config) {
          $scope.selectedscreen = 'setAutoRegSubmitFailure';
          $scope.showPass();
        });

      };
    }
  ]);
  /* registration QA/pass form has been submitted -- ends here */

})();
